// src/config/affiliates.js
//
// Affiliate configuration, in one file so tags can be rotated without
// touching any component.
//
// -----------------------------------------------------------------------
// WHY THIS IS THE RIGHT MONETISATION FOR THIS SITE
//
// A generic "buy ND filters" banner converts badly because it arrives with
// no argument. This engine produces one: it knows the reader is 7.4 stops
// over at their chosen shutter, that ND64 is the strongest filter DJI
// makes for their specific body, and that the gap leaves them short. A
// recommendation attached to a diagnosis is a different proposition from
// an ad.
//
// So the rule enforced throughout: a gear suggestion appears ONLY where
// the engine has actually computed a need. No need, no link. That's what
// keeps it from reading as advertising, and it's also why it should
// convert better than advertising.
// -----------------------------------------------------------------------

export const AFFILIATE = {
  enabled: true,

  // Buy links aren't live yet. While false, gear recommendations still show
  // (which filter/card you need) but render as plain text, not clickable
  // links. Set true once real product/affiliate URLs are in data/gear.json.
  linksLive: false,

  // PLACEHOLDERS, replace with your real tracking IDs.
  // Leave any of these empty and links for that retailer render as plain
  // untagged URLs rather than broken ones.
  tags: {
    amazon: "PLACEHOLDER-20",
    bhphoto: "PLACEHOLDER",
    adorama: "PLACEHOLDER",
  },

  /**
   * Required disclosure.
   *
   * This is not optional and not a formality. US FTC guidance requires
   * affiliate relationships to be disclosed clearly and near the link , 
   * not buried in a footer or a separate policy page. Comparable rules
   * apply in the UK, EU and elsewhere. The component below renders this
   * inline, above the links, every time.
   */
  disclosure:
    "These are affiliate links. If you buy through one, this site earns a small commission at no extra cost to you. The recommendation comes from the same exposure maths as the rest of the page, the filter shown is the one the numbers point to, whether or not there's a link attached to it.",
};

/**
 * Build an outbound URL with the tracking tag attached.
 *
 * Deliberately plain links: no pixel, no script, no third-party embed.
 * The privacy page promises this site loads nothing from anyone else, and
 * an affiliate network's tracking script would quietly break that promise
 * on every page view. A tagged href does not, nothing is requested until
 * someone clicks.
 */
export function affiliateUrl(retailer, url) {
  if (!AFFILIATE.enabled || !url) return url;
  const tag = AFFILIATE.tags[retailer];
  if (!tag || tag.startsWith("PLACEHOLDER")) return url;

  try {
    const u = new URL(url);
    if (retailer === "amazon") u.searchParams.set("tag", tag);
    else u.searchParams.set("BI", tag);
    return u.toString();
  } catch (e) {
    return url;
  }
}
